import { FilterUtil } from "../commons/FilterUtil";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "./api";
import IProvider, { IDataOptions, RequestParams } from "./IProvider";

class AProvider implements IProvider {
    path: string;
    constructor(path: string) {
        this.path = path
    }
    async list(params?: RequestParams, options?: IDataOptions): Promise<IDataResponse<any>> {
        try {
            const pathAppend: string[] = [];
            const filterString: string = params?.filter ? FilterUtil.build(params.filter) : ""

            if (filterString !== "") {
                pathAppend.push(filterString);
            }

            if (options?.limit) {
                pathAppend.push(`limit=${options.limit}`);
            }

            if (options?.page) {
                pathAppend.push(`page=${options.page}`);
            }

            if (options?.orderBy) {
                pathAppend.push(`orderBy=${options.orderBy.join(",")}`);
            }

            const request: IDataRequest = {
                url: `${params?.customPath || this.path}${pathAppend ? "?" : ""}${pathAppend.join("&")}`,
            };


            const response: IDataResponse = await api.get(request)

            if (response.statusCode === STATUS_CODE.OK) {
                return response;
            }

            return {
                data: [],
                message: "Nenhum conteúdo a ser exibido",
                statusCode: STATUS_CODE.NO_CONTENT
            };

        } catch (error) {
            return {
                data: [],
                message: "Erro ao listar usuários",
                statusCode: STATUS_CODE.INTERNAL_SERVER_ERROR
            };
        }
    }

    async find(id: number, options?: IDataOptions): Promise<IDataResponse<any>> {
        try {
            const includes: string = options ? options?.includes ? `&includes=${options.includes.join(",")}` : "" : ""
            const request: IDataRequest = {
                url: `${this.path}/${id}${options ? "?" : ""}${includes}`,
            };

            const response: IDataResponse = await api.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response;
            }

            return {
                data: [],
                message: "Nenhum conteúdo a ser exibido",
                statusCode: STATUS_CODE.NO_CONTENT
            };
        } catch (error) {
            return {
                data: [],
                message: "Erro ao buscar usuário",
                statusCode: STATUS_CODE.INTERNAL_SERVER_ERROR
            };
        }
    }

    async findByKey(key: string, value: any, params?: RequestParams, options?: IDataOptions): Promise<IDataResponse<any>> {
        try {
            const pathAppend: string[] = [];
            const includes: string = options ? options?.includes ? `includes=${options.includes.join(",")}` : "" : "";
            const filterString: string = params?.filter ? FilterUtil.build(params.filter) : "";

            if (includes !== "") {
                pathAppend.push(includes)
            }

            if (filterString !== "") {
                pathAppend.push(filterString);
            }

            const request: IDataRequest = {
                url: `${this.path}/?${key}=${value}${pathAppend.length > 0 ? "&" : ""}${pathAppend.join("&")}`,
            };

            const response: IDataResponse = await api.get(request)

            if (response.statusCode === STATUS_CODE.OK) {
                return response
            }

            return {
                data: [],
                message: "Nenhum conteúdo a ser exibido",
                statusCode: STATUS_CODE.NO_CONTENT
            }
        } catch (error) {
            return {
                data: [],
                message: "Erro ao buscar usuário",
                statusCode: STATUS_CODE.INTERNAL_SERVER_ERROR
            }
        }
    }
    delete(id: number): Promise<IDataResponse<any>> {
        throw new Error("Method not implemented.");
    }
    async save(id: string | number | undefined | null, data: any): Promise<IDataResponse<any>> {
        try {
            const isUpdate: boolean = id && id !== "" ? true : false;
            const url: string = isUpdate ? `${this.path}/${id}` : `${this.path}`;

            if (data?.valor_servico) {
                data.valor_servico = Number(data.valor_servico)
            }

            const requestConfig: IDataRequest = {
                url: `${url}`,
                data: data,
            };

            let response: IDataResponse = isUpdate
                ? await api.put(requestConfig)
                : await api.post(requestConfig);

            if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
                // notifierStore.setNotifier({
                //     content: "Registro salvo com sucesso!!",
                //     title: "Aviso",
                //     timeOut: 2500,
                //     onClose: () => notifierStore.setOpen(false),
                // });

                // notifierStore.setOpen(true);
                return response;
            }
            return {
                data: null,
                statusCode: response.statusCode,
                message: response.message,
            };
        } catch (error) {
            throw error;
        }
    }

}

export default AProvider;